import axios from "axios";

export const BASE_URL = process.env.REACT_APP_API_URL;


export const updateProfileProgram = (profileId, profileProgramId, data) => {
  return axios.patch(`${BASE_URL}profile/${profileId}/programs/${profileProgramId}/partial`, { ...data });
}